import React, { useEffect } from "react";
import { useTheme } from "../../../contexts/Theme";
import { useTranslations } from "../../../contexts/Translations";

export function CopyButton({ children, content }: { children: React.ReactNode, content: string }) {
    const theme = useTheme();
    const { translated } = useTranslations();
    const [copied, setCopied] = React.useState(false);

    useEffect(() => {
        if (copied) {
            const timeout = setTimeout(() => {
                setCopied(false);
            }, 2000);
            return () => clearTimeout(timeout);
        }
    }, [copied]);

    return <div className={"relative flex flex-row items-center"}><button onClick={() => {
        navigator.clipboard.writeText(content)
        setCopied(true);
    }}
        className="rounded-full p-1 underline m-1 flex font-medium items-center">
        {children}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="gray" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
        </svg>
    </button>
        {copied && <span className="animate-bounce text-xs absolute bottom-full bg-white rounded-full p-2 shadow translate-y-1">{translated("copied")}</span>}
    </div>
}